<template>
	<div class="page" v-loading="loading">
		<gc-header headerData="directDetail"></gc-header>
		<div class="page-main directive-detail-main">
			<gc-group-detail :data="basicInfoData">
				<template #importFailCount>
					<div>
						{{ basicInfo.importFailCount || 0 }}
						<a v-if="basicInfo.importFailCount" class="download" @click="handleDownloadImportFail">
							下载失败明细
						</a>
					</div>
				</template>
				<template #waitCount>
					<div>
						<span @click="handleSearchQuery('0')" class="query-count">{{ basicInfo.waitCount || 0 }}</span>
					</div>
				</template>
				<template #successCount>
					<div>
						<span @click="handleSearchQuery('1')" class="query-count">
							{{ basicInfo.successCount || 0 }}
						</span>
					</div>
				</template>
				<template #failCount>
					<div>
						<span @click="handleSearchQuery('2')" class="query-count">{{ basicInfo.failCount || 0 }}</span>
					</div>
				</template>
				<template #reviewStatus>
					<span>{{ statusMap[basicInfo.reviewStatus] }}</span>
				</template>
			</gc-group-detail>
			<div class="basic-info"></div>
			<div class="directive-detail-table-show">
				<div class="table-header">
					<span>指令执行表具监控</span>
					<el-button
						v-if="tenantType === '1' && $has('monitor:run:batch-command:resend')"
						v-click-blur
						type="primary"
						:disabled="!(queryParams.status == 2 && tableData.length > 0)"
						@click="handleReSend"
					>
						指令补发
					</el-button>
				</div>
				<div class="table-box">
					<div class="search-box">
						<div class="search-items">
							<gc-custom-search
								width="300px"
								class="search"
								key-word="设备通讯编号"
								:search.sync="params['deviceNo']"
							></gc-custom-search>
							<gc-custom-search
								width="300px"
								class="search"
								key-word="执行状态"
								type="select"
								:search-option="commandStatus"
								:search.sync="params['status']"
								:search-option-key="{ label: 'name', value: 'defaultValue' }"
								needAllForSearch
							></gc-custom-search>
						</div>
						<div class="search-btns">
							<el-button v-click-blur type="primary" class="query" @click="query">查 询</el-button>
							<el-button v-click-blur @click="reset">重 置</el-button>
							<el-button v-click-blur type="primary" class="query" @click="handleDownload">
								导出
							</el-button>
						</div>
					</div>
					<gc-table
						class="table-content"
						:columns="columns"
						:table-data="tableData"
						:border="true"
						:showPage="true"
						pagination-type="special"
						:page-params="pageParams"
						@current-page-change="currentPageChange"
					></gc-table>
				</div>
			</div>
		</div>
		<command-detail :visible.sync="visible" :commandDetailData="commandDetailData"></command-detail>
	</div>
</template>

<script>
import { apiBatchCommandDetailList, apiGetBasicInfo, apiReSend } from '@/apis/batchDirectiveManage.api.js'
import CommandDetail from './CommandDetail.vue'
import { isBlank } from '@/utils/validate'
import { exportReport } from '@/apis/statisticAnalysis.api'
const statusMap = {
	0: '未审核',
	1: '已审核',
	2: '审核未通过',
	3: '已取消',
}
export default {
	name: 'directDetail',
	components: { CommandDetail },
	data() {
		return {
			statusMap,
			columns: [
				{
					key: 'deviceNo',
					name: '设备通讯编号',
				},
				{
					key: 'ts',
					name: '创建时间',
				},
				{
					key: 'status',
					name: '执行状态',
					render: (h, row) => {
						const statusMap = {
							0: { class: 'dot-warning', text: '待执行' },
							1: { class: 'dot-success', text: '成功' },
							2: { class: 'dot-error', text: '失败' },
							3: { class: 'dot-error', text: '人工取消' },
						}
						const val = row.status
						return h(
							'span',
							{ class: isBlank(val) ? '' : statusMap[val]?.['class'] },
							isBlank(val) ? '--' : statusMap[val]?.['text'],
						)
					},
				},
				{
					key: 'ops',
					name: '操作',
					render: (h, row) => {
						//  自定义表格内容展示
						return h(
							'el-button',
							{
								props: {
									type: 'text',
									size: 'medium',
								},
								on: {
									click: () => {
										this.commandDetailData.map(item => {
											if (Object.prototype.hasOwnProperty.call(row, item.key)) {
												if (item.key == 'detail') {
													item.value = row[item.key] || {}
												} else {
													item.value = row[item.key] || '--'
												}
											}
										})
										this.visible = true
									},
								},
							},
							'查看指令详情',
						)
					},
				},
			],
			tableData: [],
			pageParams: {
				hasNext: false,
				idOffset: '', //下一页offset
				currentIdOffset: '', //当前请求offset
			},
			visible: false,
			commandDetailData: [
				{
					key: 'deviceNo',
					label: '设备通讯编号',
					value: '',
				},
				{
					key: 'detail',
					label: '指令内容',
					value: {},
				},
			],
			basicInfo: {},
			loading: false,
			params: {
				deviceNo: null,
				status: null,
			},
			queryParams: {},
		}
	},
	computed: {
		basicInfoData() {
			let obj = {
				title: '基本属性',
				row: 4,
				list: [
					{
						key: 'deviceTypeName',
						label: '设备类型',
						value: '--',
					},
					{
						key: 'userTypeName',
						label: '客户类型',
						value: '--',
						tenantType: '1',
					},
					{
						key: 'waterRegionName',
						label: '所属区域',
						value: '--',
						tenantType: '1',
					},
					{
						key: 'orgName',
						label: '所属机构',
						value: '--',
					},
					{
						key: 'cmdModelName',
						label: '指令名称',
						value: '--',
					},
					{
						key: 'createTime',
						label: '导入时间',
						value: '--',
					},
					{
						key: 'importCount',
						label: '导入总数',
						value: '--',
					},
					{
						key: 'importSuccessCount',
						label: '导入成功数',
						value: '--',
					},
					{
						key: 'importFailCount',
						label: '导入失败数',
						value: '--',
						slot: 'importFailCount',
					},
					{
						key: 'cancelCount',
						label: '人工取消数',
						value: '--',
					},
					{
						key: 'waitCount',
						label: '待执行数',
						value: '--',
						slot: 'waitCount',
					},
					{
						key: 'successCount',
						label: '执行成功数',
						value: '--',
						slot: 'successCount',
					},
					{
						key: 'failCount',
						label: '执行失败数',
						value: '--',
						slot: 'failCount',
					},
					{
						key: 'reviewStatus',
						label: '审核状态',
						value: '--',
						slot: 'reviewStatus',
					},
					{
						key: 'reviewTime',
						label: '审核时间',
						value: '--',
					},
					{
						key: 'reviewStaff',
						label: '审核人',
						value: '--',
					},
				],
			}
			obj.list = obj.list.filter(item => isBlank(item.tenantType) || item.tenantType === this.tenantType)
			obj.list.map(item => {
				if (!isBlank(this.basicInfo[item.key])) {
					item.value = this.basicInfo[item.key].toString()
				}
			})
			return obj
		},
		tenantType() {
			return this.$store.getters.userInfo.tenantType
		},
		taskNo() {
			return this.$route.query.taskNo
		},
		commandTaskId() {
			return this.$route.query.commandTaskId
		},
		commandStatus() {
			return this.$store.getters.dataList.commandStatus || []
		},
	},
	methods: {
		// 指令执行表具监控列表
		getCommandDetailList(currentIdOffset) {
			this.loading = true
			this.pageParams.currentIdOffset = currentIdOffset
			let params = Object.assign(
				{
					limit: 10,
					idOffset: this.pageParams.currentIdOffset,
				},
				{
					taskNo: this.taskNo,
					...this.params,
				},
			)
			this.queryParams = JSON.parse(JSON.stringify(params))
			apiBatchCommandDetailList(params)
				.then(res => {
					this.pageParams.hasNext = res.hasNext
					this.pageParams.idOffset = res.idOffset
					this.tableData = res.records || []
				})
				.finally(() => {
					this.loading = false
				})
		},
		// 翻页
		currentPageChange(currentIdOffset) {
			this.getCommandDetailList(currentIdOffset)
		},
		//请求批量指令字段信息
		getBasicInfo(params) {
			apiGetBasicInfo(params).then(res => {
				this.basicInfo = res || {}
			})
		},
		reset() {
			this.params.status = null
			this.params.deviceNo = null
			this.getCommandDetailList('')
			this.queryParams = {}
		},
		query() {
			this.getCommandDetailList('')
		},
		handleSearchQuery(status) {
			this.params.deviceNo = null
			this.params.status = status
			this.query()
		},
		handleReSend() {
			this.$confirm('你确定要补发指令吗？').then(() => {
				this.loading = true
				apiReSend({
					taskNo: this.taskNo,
					status: this.queryParams.status,
					commandTaskId: this.basicInfo.commandTaskId,
				})
					.then(() => {
						this.$message.success('指令补发成功')
						this.query()
					})
					.finally(() => {
						this.loading = false
					})
			})
		},
		handleDownload() {
			this.$toast('下载中，请稍后...')
			const data = {
				method: 'post',
				url: '/monitor/report/command-task/sendfail/excel',
				fileName: '指令执行明细.xlsx',
				data: { ...this.queryParams, idOffset: undefined, limit: undefined },
			}
			exportReport(data, 'excel', {}, this.$toast)
		},

		handleDownloadImportFail() {
			this.$toast('下载中，请稍后...')
			const data = {
				method: 'post',
				url: '/monitor/report/command-task/importfail/excel',
				fileName: '指令导入失败明细.xlsx',
				data: { taskNo: this.taskNo },
			}
			exportReport(data, 'excel', {}, this.$toast)
		},
	},
	activated() {
		this.params.status = null
		this.queryParams = {}
		this.getCommandDetailList('')
		this.getBasicInfo({
			commandTaskId: this.commandTaskId,
		})
	},
}
</script>
<style lang="scss" scoped>
@import '../runLayout.scss';
.directive-detail-main {
	flex-direction: column;
	padding: 0 24px;
	.directive-detail-table-show {
		flex: 1;
		display: flex;
		flex-direction: column;
		height: 0;
		.table-header {
			font-size: 16px;
			font-weight: 600;
			color: #333333;
			padding-bottom: 20px;
			display: flex;
			justify-content: space-between;
		}
		.table-box {
			flex: 1;
			height: 0;
			display: flex;
			flex-direction: column;
			.search-box {
				box-sizing: border-box;
				display: flex;
				.search-items {
					flex: 1;
					width: 0;
					display: flex;
					align-items: center;
					.search {
						margin-right: 12px;
					}
				}
				.search-btns {
					display: flex;
					justify-content: center;
					margin-left: auto;
					.el-button {
						& + .el-button {
							margin-left: 12px;
						}
					}
				}
			}

			.table-content {
				flex: 1;
				height: 0;
				margin-top: 12px;
			}
		}
	}
}
::v-deep .desc {
	.el-textarea.is-disabled .el-textarea__inner {
		border: 1px solid #d9d9d9;
		background: #ffffff !important;
		color: #4e4e4e;
	}
}
.download {
	margin-left: 6px;
}
.query-count {
	color: #4d6bff;
	cursor: pointer;
}
</style>
